'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="mx-auto flex min-h-[50vh] w-full max-w-3xl flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
      <h2 className="text-3xl font-bold text-white">Une erreur est survenue</h2>
      <p className="mt-3 max-w-xl text-white/70">
        Un problème inattendu est survenu pendant le chargement de la page. Vous pouvez réessayer immédiatement.
      </p>
      <Button type="button" variant="cta" className="mt-6" onClick={reset}>
        Réessayer
      </Button>
    </div>
  );
}
